import { Component,OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { YubikeyService } from 'src/app/services/yubikey.service';
import { environmentConfig } from '../../../../environment';
import { HttpClient } from '@angular/common/http';
import * as dayjs from 'dayjs';
import * as tz from 'dayjs/plugin/timezone';
import * as utc from 'dayjs/plugin/utc';
import * as duration from 'dayjs/plugin/duration';



@Component({
  selector: 'app-smc',
  templateUrl: './register_yubi.component.html',
  styleUrls: ['./register_yubi.component.css']
})
export class RegisterYubikeyComponent implements OnInit {
  
  apiUrl = environmentConfig.apiBaseUrl;
  userID: any = sessionStorage.getItem('wOSAuthUser');
  userPrefs: any = sessionStorage.getItem('wOSUserPrefs');
  userEmail = JSON.parse(this.userPrefs).w_email;
  user: any = sessionStorage.getItem('wOSUser');
  userRole: any = sessionStorage.getItem('wOSUserRole');
  userName = JSON.parse(this.userPrefs).old_name;
  token = JSON.parse(this.user).stsTokenManager.accessToken;
  returnVal: any = "";
  registeredKeys: any[] = [];
  passkeyName = "";
  errorMsg = "";



  constructor(
    private router: Router,
    private authService: AuthService,
    private yubiService: YubikeyService,
    private sanitizer: DomSanitizer,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    console.log("Initialized Enrollment screen");
    this.getRegisteredData()
    console.log(JSON.parse(this.userPrefs).w_email)
  }

  getRegisteredData(): void {
    this.yubiService.getRegisteredKeys(this.userID).then(keys => {
      this.registeredKeys = keys;
      console.log("Registered keys", this.registeredKeys);
      setTimeout(() => {
        $("#passKeyName").trigger("focus");
        console.log("Focus triggered on passKeyName input");
      }, 750);
    })
  }

  get filteredItems() {
    console.log(window.location.hostname);
    return this.registeredKeys.filter(item =>
      item.passkey_domain.toLowerCase().includes(window.location.hostname)
    );
  }

  enrollYubikey(): void {
    if (this.passkeyName.trim() == "") {
      this.errorMsg = "Please enter a passkey name to continue.";
      this.clearErrorState();
      $("#passkeyName").focus();
      return;

    }
    this.yubiService.enrollYubikey(this.userEmail, this.passkeyName).then(r => {
      this.returnVal = JSON.stringify(r);
      this.getRegisteredData();
      this.clearReturnVal();
      this.resetInputs();
    })
  }

  loginTest(): void {
    this.yubiService.login(this.userEmail).then(r => {
      this.returnVal = JSON.stringify(r);
      this.clearReturnVal();
    })
  }

  deleteKey(keyId: number, hash: string, storage:string): void {
    const loc = storage.toLowerCase().includes("computer");
    const pin = (loc) ? '99999' : prompt("Enter the PIN for this Yubikey to confirm deletion:");
    console.log("Deleting key with ID", keyId, "and hash", hash, "from storage", storage, "with location flag", loc,"and pin",pin);


    if (!pin) {
      alert("PIN is required to delete a Yubikey.");
      return;
    }

    this.yubiService.deleteKey(keyId, hash,pin!,loc).then(r => {
      this.returnVal = "Delete status - " + r.status;
      this.getRegisteredData();
      this.clearReturnVal();
      this.resetInputs();
    }).
      catch(err => {
        console.log("Error deleting key", err);
        this.returnVal = "Error deleting key: " + err.error.status;
        this.clearReturnVal();
      })
  }

  formatDate(dt: string) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return dayjs.utc(dt).tz(timezone).format("DD MMM YYYY h:mmA");
  }

  clearErrorState(): void {
    setTimeout(() => {
      this.errorMsg = "";
    }, 5000)
  }

  clearReturnVal(): void {
    setTimeout(() => {
      this.returnVal = "";
    }, 5000)
  }

  resetInputs(): void {
    this.passkeyName = "";
    $("#passKeyName").trigger("focus")
  }
}
